import { CalendarMonthOutlined } from "@mui/icons-material";
import {
  Box,
  ClickAwayListener,
  Fade,
  Paper,
  Popover,
  Popper,
  Typography,
} from "@mui/material";
import { useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { searchStoreActions, selectFilter } from "../saga/searchStoreSlice";
import { LocalizationProvider, DateCalendar } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ISearchFilter } from "../models";
import { Dayjs } from "dayjs";

function DatePickerButton({
  onChange,
}: {
  onChange: (value: Dayjs | null) => void;
}) {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const [dateData, setDateData] = useState<Dayjs | null | undefined>(null); // [1
  const buttonRef = useRef<HTMLDivElement | null>(null);

  const filter = useAppSelector(selectFilter);
  const dispatch = useAppDispatch();

  const handleClick = (event: any) => {
    setAnchorEl(anchorEl ? null : buttonRef.current);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChangeData = (value: any) => {
    setDateData(value);
    onChange(value);
    handleClose();
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Paper
        ref={buttonRef}
        sx={{
          display: "flex",
          position: "relative",
          alignItems: "center",
          p: 1,
          my: 1,
          cursor: "pointer",
        }}
        onClick={handleClick}
      >
        <CalendarMonthOutlined color="primary" sx={{ px: 1 }} />
        <Typography>
          {filter.date
            ? filter.date?.format("M月D日（ddd）")
            : "指定なし"}
        </Typography>
      </Paper>

      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="right-start"
        transition
        disablePortal
        modifiers={[
          {
            name: "preventOverflow",
            enabled: true,
            options: {
              altAxis: true,
              altBoundary: true,
              tether: true,
              rootBoundary: "document",
              padding: 8,
            },
          },
          {
            name: "offset",
            enabled: true,
            options: {
              offset: [-20, 20],
            },
          },
        ]}
        sx={{
          position: "relative",
          left: "20px",
          overflowX: "unset",
          overflowY: "unset",
          boxShadow: 1,
          zIndex: 5,
          "&::before": {
            boxShadow: "-8px 0px 6px -4px rgba(0, 0, 0, 0.1)",
            backgroundColor: "white",
            content: '""',
            display: "block",
            position: "absolute",
            width: 20,
            height: 20,
            top: "40px",
            transform: "translateY(-50%) rotate(45deg)",
            left: "-10px",
          },
        }}
      >
        {({ TransitionProps }) => (
          <ClickAwayListener onClickAway={handleClose}>
            <Fade {...TransitionProps} timeout={250}>
              <Box bgcolor="white" zIndex={120}>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ja">
                  <DateCalendar
                    value={dateData}
                    disablePast
                    onChange={handleChangeData}
                  />
                </LocalizationProvider>
              </Box>
            </Fade>
          </ClickAwayListener>
        )}
      </Popper>
    </>
  );
}

export default DatePickerButton;
